import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSort, Sort, SortDirection } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Partner } from '../../../models/partner';
import { PartnerService } from '../../../services/partner.service';
import { Router } from '@angular/router';

const PRO_STATUS_ORDER = {
  'Incomplete': 0,
  'Pending Approval': 1,
  'Completed': 2
};
@Component({
  selector: 'app-partner-management',
  templateUrl: './partner-management.component.html',
  styleUrls: ['./partner-management.component.scss']
})
export class PartnerManagementComponent implements OnInit {

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  dataSource: MatTableDataSource<any>;
  currentSortColumn: string | null = null;
  currentSortDirection: string | null = null;

  displayedColumns = ['name', 'earningsYtd', 'proStatus', 'action']

  partners: Partner[] = [];

  constructor(private router: Router, private partnerService: PartnerService) { }

  ngOnInit() {

    this.partnerService.getPartners().subscribe(x => {
      this.partnerService.setPartners(x);
    });


    this.partnerService.partners$.subscribe((x) => {
      this.partners = x;

      this.dataSource = new MatTableDataSource(this.partners);

      //CUSTOM SORTING BELOW IS NOT WORKING CORRECTLY

      //provide custom sorting for proStatus column
      this.dataSource.sortingDataAccessor = (item, property) => {
        switch (property) {
          case 'proStatus':
            let index = PRO_STATUS_ORDER[item.proStatus] ?? -1;
            return index;
          default:
            return item[property] ?? '';
        }
      };

      //this.dataSource.sort = this.sort;
    })
  }

  ngAfterViewInit() {
    // this.dataSource.sort = this.sort;
    this.sort.sortChange.subscribe((sort: Sort) => {
      console.log(sort);
      this.currentSortColumn = sort.active;
      this.currentSortDirection = sort.direction;

      if (sort.active === 'name') {
        this.sortByPartners(sort.direction);
      }
    });
  }

  navigateToDetails(partner: Partner) {

    this.partnerService.selectedPartnerId = partner.id;
    this.partnerService.setSelectedPartner(partner);

    this.router.navigate(['data/partners/details', partner.id])
  }

  //sorts the partners list alphabetically a-z or z-a, in the direction MatSort reports
  //for the PARTNER header. The direction must come from the click, not the data: the
  //api already returns partners a-z, so "reverse if already sorted" turned the first
  //click into z-a while the arrow said ascending
  sortByPartners(direction: SortDirection) {

    //Note: we want to keep Mibe Music at the top
    //Note: Mibe Music will be placed back at the front of the list through the partnerService.setPartners function

    //a cleared sort ('') goes back to the api's default order, a-z
    this.partners.sort((a, b) => a.name.localeCompare(b.name));
    if (direction === 'desc') {
      this.partners.reverse();
    }

    //update global partners variable
    this.partnerService.setPartners(this.partners);
  }


  //sorts the partners list by earnings
  sortByEarnings() {
    // Check to see if the array is already sorted by earningsYTD in ascending order
    const isSorted = this.partners.every((item, index) => {
      // Ensure that 'Mibe Music' remains at the top
      var ordered =
        index === 0 || 
        item.earningsYTD <= this.partners[index - 1].earningsYTD || 
        (index - 1 === 0 && this.partners[index - 1].name === 'Mibe Music');
      
      return ordered;
    });
  
    if (isSorted) {
      // Reverse the array if it's already sorted by earningsYTD
      this.partners.reverse();
    } else {
      // Sort by earningsYTD (ascending order)
      this.partners.sort((a, b) => b.earningsYTD - a.earningsYTD);
    }
  
    // Update the global partners variable
    this.partnerService.setPartners(this.partners);
  }

  //sorts the partners list by pro status 
  sortByProStatus() {
    const statusOrder = ["Incomplete", "Pending Approval", "Completed"];
  
    // Check if the array is already sorted in the desired order
    const isSorted = this.partners.every((item, index) => {
      const currentStatusIndex = statusOrder.indexOf(item.proStatus);
      const previousStatusIndex = index === 0 ? -1 : statusOrder.indexOf(this.partners[index - 1].proStatus);
      
      var ordered = index === 0 || currentStatusIndex >= previousStatusIndex || (index - 1 === 0 && this.partners[index - 1].name === 'Mibe Music');
      
      return ordered;
    });
  
    if (isSorted) {
      // Reverse the array if it's already sorted by proStatus
      this.partners.reverse();
    } else {
      // Sort by proStatus based on the defined order
      this.partners.sort((a, b) => statusOrder.indexOf(a.proStatus) - statusOrder.indexOf(b.proStatus));
    }
  
    // Update the global partners variable
    this.partnerService.setPartners(this.partners);
  }

  getSortDirection(column: string): string | null {
    return this.currentSortColumn === column ? this.currentSortDirection : null;
  }
  
}
